import { forwardRef } from 'react'
import { BrowserTypeEnum } from "../types/browserTypeEnum";
import { getBrowserType } from "../modules/deviceModel";
import NativeScroll from "./nativeScroll";
import ScrollWrapper, {
  ScrollWrapperProps,
  ScrollWrapperRef
} from "./scrollWrapper";

const ScrollWrapperLoader = forwardRef<ScrollWrapperRef, ScrollWrapperProps>(
  ({...props}, ref) => {
    const browser = getBrowserType();
    if (browser == BrowserTypeEnum.ThirdGen) {
      return <NativeScroll {...props} ref={ref} />
    }
    return <ScrollWrapper {...props} ref={ref} />
  }
)
export default ScrollWrapperLoader;
